import { flushSync } from 'react-dom'

/**
 * Forces React to commit the state update synchronously (flushSync), then
 * waits one requestAnimationFrame so the browser actually paints the spinner
 * before the async API call begins.
 *
 * Without flushSync: React 19 automatic batching may never render the spinner.
 * Without the rAF wait: the browser may not paint before a fast API resolves.
 */
export function flushToPaint(fn: () => void): Promise<void> {
  flushSync(fn)
  return new Promise<void>((resolve) => requestAnimationFrame(() => resolve()))
}
